import type { PortableTextBlock, PortableTextTextBlock } from "sanity";

const SG_LINK_REGEX = /\/streamingguide\/(?:serie|film)\/(\d+)/i;
export function replaceOldStreamingProviderLinks(text: PortableTextBlock[]): PortableTextBlock[] {
    return text.map(ptb => {
        // do we have any marks with a streaming link?
        let streamingId: number = 0;
        const sgLinkMarkDef = (ptb as PortableTextTextBlock).markDefs?.some(markDef => {
            if (markDef?._type === "link" && markDef.href) {
                const linkMatch = SG_LINK_REGEX.exec(markDef.href as string);
                if (linkMatch) {
                    streamingId = Number(linkMatch[1]);
                    return true;
                }
                return false;
            }
            return false;
        });

        if (sgLinkMarkDef && streamingId > 0) {
            // we have a streaming link. Check if the text seems to be the old "Se hvor du kan streame den her"
            const isProviderLink = (ptb as PortableTextTextBlock).children?.some((ptts => {
                return ptts.text && (ptts.text as string).startsWith("Se hvor du kan streame");
            }));

            if (isProviderLink) {
                return {
                    _key: ptb._key,
                    _type: "streamingProviders",
                    streamingId: streamingId
                } as PortableTextBlock;
            }
        }

        return ptb;
    });
}